module.exports = __webpack_public_path__ + "static/media/galerija_2013 (23).a8285ec7.jpg";